<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="flangeFacing_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Joint Facing -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.JOINT_FACING' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #flangeFacing_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.JOINT_FACING' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select
        formControlName="flangeFacingType"
        name="joint_facing"
        class="mat-select-general input-form-class"
        [class.spinner]="loading"
        [class.select-disable]="enable"
    >
        <mat-option class="option-list" *ngFor="let fftl of flangeFacingTypeList" [value]="fftl.flangeFacingTypeId">
            {{ fftl.flangeFacingTypeName }}</mat-option
        >
    </mat-select>
</div>
